/** Quartal (1–4) zu einem ISO-Datum 'YYYY-MM-DD'. */
export function quarterOf(isoDate) {
    const m = Number(isoDate.slice(5, 7));
    if (!Number.isInteger(m) || m < 1 || m > 12)
        throw new Error(`Ungültiges Datum: ${isoDate}`);
    return (Math.floor((m - 1) / 3) + 1);
}
/** Initialen aus einem Namen: „Matthias Brunner“ → „MB“. */
export function initialsOf(name) {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    const first = parts[0]?.[0] ?? '';
    const last = parts.length > 1 ? parts[parts.length - 1]?.[0] ?? '' : '';
    return (first + last).toUpperCase() || '?';
}
//# sourceMappingURL=dates.js.map